import React, { useState, useEffect, useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { contentClient } from "../../../AxiosClient.js";
import { useSnackbar } from "notistack";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import CardContent from "@material-ui/core/CardContent";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { useSelector } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import ActionButton from "../../ActionButton";
import Alert from "@material-ui/lab/Alert";
import PropertyNames from "../../../PropertyNames";
import DisplayUser from "../../user/DisplayUser";
import Tooltip from "@material-ui/core/Tooltip";
import KpsListItem from "../../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";

import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import moment from "moment";
import { currentUserHasRole, Role } from "../../../utils/RoleUtils";
import CheckIcon from "@material-ui/icons/Check";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { taxServiceClient } from "../../../AxiosClient";

const useStyles = makeStyles((theme) => ({
  stepper: {
    color: `${theme.palette.primary.main} !important`,
  },
  skeleton: {
    margin: 5,
  },
  timelineSeparator: {
    // minHeight: "40px",
  },
  timeLineContent: {
    marginTop: "-26px",
    padding: "6px 8px",
  },
  timeLineContentNoExp: {
    marginTop: "-18px",
    padding: "6px 8px",
  },
  timelineDot: {
    marginTop: 0,
    marginBottom: 0,
  },
  timelineDotPublished: {
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: `${theme.palette.success.main}`,
    marginLeft: -8,
    color: "white",
    border: 0,
  },
  timelineDotRemoved: {
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: `${theme.palette.error.main}`,
    marginLeft: -8,
    color: "white",
    border: 0,
  },
  timelineDotSuperseded: {
    marginTop: 0,
    marginBottom: 0,
    backgroundColor: `${theme.palette.info.main}`,
    marginLeft: -8,
    color: "white",
    border: 0,
  },
  connectorEnabled: {
    backgroundColor: theme.palette.secondary.main,
  },
  connectorEnabledMargin: {
    backgroundColor: theme.palette.secondary.main,
    marginLeft: -8,
  },
  connectorDisabled: {
    backgroundColor: theme.palette.text.disabled,
  },
  connectorDisabledMargin: {
    backgroundColor: theme.palette.text.disabled,
    marginLeft: -8,
  },
  checkmark: {
    margin: "0 auto",
    width: 150,
    height: 150,
    borderRadius: "50%",
    display: "block",
    strokeWidth: 2,
    stroke: "#fff",
    strokeMiterlimit: 10,
    boxShadow: "inset 0px 0px 0px #7ac142",
    animation:
      "$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both",
  },
  checkmarkCircle: {
    strokeDasharray: 166,
    strokeDashoffset: 166,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#7ac142",
    fill: "none",
    animation: "$stroke .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards",
  },
  checkmarkCheck: {
    transformOrigin: "50% 50%",
    strokeDasharray: 48,
    strokeDashoffset: 48,
    animation:
      "$stroke .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards",
  },
  "@keyframes fill": {
    "100%": {
      boxShadow: "inset 0px 0px 0px 100px #7ac142",
    },
  },
  "@keyframes scale": {
    "0%, 100%": {
      transform: "none",
    },
    "50%": {
      transform: "scale3d(1.1, 1.1, 1)",
    },
  },
  "@keyframes stroke": {
    "100%": {
      strokeDashoffset: 0,
    },
  },
  "@global": {
    ".MuiTimelineItem-missingOppositeContent:before": {
      flex: 0,
    },
  },
  commentContainer: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: theme.palette.text.secondary,
  },
  container: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(3),
    marginTop: 0,
  },
  timelineRoot: {
    padding: "6px 0px",
  },
}));

function SidebarWorkflow(props) {
  const { t } = useTranslation();
  const [workflowText, setWorkflowText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hasReworks, setHasReworks] = useState(false);
  const [workflowComplete, setWorkflowComplete] = useState(false);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const currentUser = useSelector((state) => state.user.currentUser);
  // const reviewOwn = useSelector(
  //   (state) =>
  //     state.setting.applicationProperties[
  //       PropertyNames.REVIEW_OWN_KNOWLEDGE
  //     ] === "true"
  // );
  // const approveOwn = useSelector(
  //   (state) =>
  //     state.setting.applicationProperties[
  //       PropertyNames.APPROVE_OWN_KNOWLEDGE
  //     ] === "true"
  // );
  const defaultWorkflowUsers = {reviewers: 0, approvers: 0, publishers: 0}
  const isSysAdmin = currentUserHasRole(Role.SYSTEM_MANAGER) ? true : false

  const [publishedBy, setPublishedBy] = useState();
  const [madeDraftBy, setMadeDraftBy] = useState();
  const [selectedRevision, setSelectedRevision] = useState({});

  const [workflowActive, setWorkflowActive] = useState(false)
  const [workflowUsers, setWorkflowUsers] = useState(defaultWorkflowUsers)
  const [workflowTeams, setWorkflowTeams] = useState({})
  const [reviewInTaxWorkflow, setReviewInTaxWorkflow] = useState(false)
  const [approveInTaxWorkflow, setApproveInTaxWorkflow] = useState(false)
  const [publishInTaxWorkflow, setPublishInTaxWorkflow] = useState(false)
  const [effectiveCurrentStage, setEffectiveCurrentStage] = useState()
  const [buttonText, setButtonText] = useState("")
  const [hasBeenFullyReviewed, setHasBeenFullyReviewed] = useState(false)
  const [hasBeenFullyApproved, setHasBeenFullyApproved] = useState(false)
  const [totalReviewersRequiredToComplete,setTotalReviewersRequiredToComplete] = useState(0)
  const [totalApproversRequiredToComplete,setTotalApproversRequiredToComplete] = useState(0)

  useEffect(() => {
    if (props.internalDocument) {
      setSelectedRevision(props.internalDocument);
      props.internalDocument.contentRVO.madeDraftBy &&
        setMadeDraftBy(props.internalDocument.contentRVO.madeDraftBy)
      props.internalDocument.contentRVO.publishedBy &&
        setPublishedBy(props.internalDocument.contentRVO.publishedBy)
    }
  }, []);

  useEffect(() => {
    if (selectedRevision.contentRVO) {
      let reviewsNeeded = selectedRevision.contentRVO.workflow.reviewersRequired
      if ( selectedRevision.contentRVO.workflowState !== "AWAITING_REVIEW" && 
        selectedRevision.contentRVO.workflow.reviewersRequired !== selectedRevision.contentRVO.reviewers.length ) {
        /* 
          this adjusts the totals shown to handle the case where knowledgesource values have changed since a 
          revision was reviewed and we have to assume that the previous value was reached in order to proceed
        */ 
        reviewsNeeded = selectedRevision.contentRVO.reviewers.length
      } 
      setTotalReviewersRequiredToComplete(reviewsNeeded)
      
      let approvalsNeeded = selectedRevision.contentRVO.workflow.approversRequired
      if ( selectedRevision.contentRVO.workflowState !== "AWAITING_REVIEW" &&
        selectedRevision.contentRVO.workflowState !== "AWAITING_APPROVAL" && 
        selectedRevision.contentRVO.workflow.approversRequired !== selectedRevision.contentRVO.approvers.length ) {
        /* 
          this adjusts the totals shown to handle the case where knowledgesource values have changed since a 
          revision was approved and we have to assume that the previous value was reached in order to proceed
        */ 
        approvalsNeeded = selectedRevision.contentRVO.approvers.length
      }
      setTotalApproversRequiredToComplete(approvalsNeeded)


      let fullyReviewed = (selectedRevision.contentRVO.workflow 
        && selectedRevision.contentRVO.workflow.reviewersRequired) 
        ? selectedRevision.contentRVO.reviewers.length>= reviewsNeeded
        : false;
      setHasBeenFullyReviewed(fullyReviewed)
      

      
      let fullyApproved = (selectedRevision.contentRVO.workflow 
        && selectedRevision.contentRVO.workflow.approversRequired) 
          ? selectedRevision.contentRVO.approvers.length >= approvalsNeeded 
          : false;
      setHasBeenFullyApproved(fullyApproved)
      

    }
  },[selectedRevision,props.internalDocument])

  useEffect(
    () => {
      setWorkflowActive(isWorkflowActive())
      if (props.internalDocument && !props.internalDocument.hasDraft) {
        setIsLoading(false);
      }
      if (props.internalDocument && !props.internalDocument.contentRVO.live) {
        setIsLoading(false);
        setSaving(false);
        contentClient
          .post("/rework/filter", {
            targetId: props.internalDocument.contentRVO.revisionId,
            status: "OPEN",
          })
          .then((res) => {
            setHasReworks(res.data.content && res.data.content.length > 0);
          });
      }
      if (props.internalDocument && !props.isRevision) {
        setSelectedRevision(props.internalDocument);
      }
    },
    [props.internalDocument]
  );

  useEffect(
    () => {
      const topicId = props.internalDocument.contentRVO.topic 
        ? props.internalDocument.contentRVO.topic.topicId
        : props.internalDocument.contentRVO.topicId

      const classification = props.internalDocument.contentRVO.knowledgeSource
        ? props.internalDocument.contentRVO.knowledgeSource.classification
        : props.internalDocument.documentRVO.classification

      if (workflowActive === true) {
        taxServiceClient
        .get(`/topic/${topicId}/workflowsummary/${classification}/`)
        .then((res) => {
          if (res.data) {
            //Note that this is a list of available users who can see the topic and have each of the roles.  
            //Workflow only applies if there are user to carry it out 
            setWorkflowUsers(res.data)
          }
        });
      } else {
        setWorkflowUsers(defaultWorkflowUsers)
      }
    },
    [workflowActive]
  )

  useEffect(
    () => {
      if (workflowActive === true) {
        const topicId = props.internalDocument.contentRVO.topic 
        ? props.internalDocument.contentRVO.topic.topicId
        : props.internalDocument.contentRVO.topicId
    
        let topic = props.taxonomyNodeLookup.filter(t => t.id === topicId && t.type === "topic")[0]
        if (topic) {
          let parents = props.taxonomyNodeLookup.filter(
            t => topic.parentList.includes(t.id) 
            && t.type === "taxonomy" 
          )
          let teams = []
          parents.forEach(p => {
            teams = teams.concat(p.children.filter(c => c.type === "team").filter(c => c.object &&
              c.object.approver === true || c.object.reviewer === true || c.object.publisher === true))
          })
          setWorkflowTeams(teams)
          let hasReviewerTeams = (teams.length > 0 && teams.filter(t => t.object.reviewer === true).length > 0) ? true : false
          setReviewInTaxWorkflow(hasReviewerTeams)
          let hasApproverTeams = teams.length > 0 && teams.filter(t => t.object.approver === true).length > 0 ? true : false
          setApproveInTaxWorkflow(hasApproverTeams)
          let hasPublisherTeams = teams.length > 0 && teams.filter(t => t.object.publisher === true).length > 0 ? true : false
          setPublishInTaxWorkflow(hasPublisherTeams)    
        }
      }
    },[workflowUsers]
  )

  useEffect(
    () => {
      if (selectedRevision.contentRVO) {
        const revisionState = selectedRevision.contentRVO.workflowState
        let currentStage = revisionState
        switch (revisionState) {
          case "AWAITING_REVIEW" :
            currentStage = (reviewInTaxWorkflow && !hasBeenFullyReviewed)
              ? revisionState 
              : (approveInTaxWorkflow && !hasBeenFullyApproved)
                ? "AWAITING_APPROVAL"
                : publishInTaxWorkflow
                  ? "AWAITING_PUBLISH"
                  : revisionState
            break 
          case "AWAITING_APPROVAL":
            currentStage = approveInTaxWorkflow && (!reviewInTaxWorkflow || hasBeenFullyReviewed)
            ? revisionState 
            : (reviewInTaxWorkflow && !hasBeenFullyReviewed)
              ? "AWAITING_REVIEW"
              : publishInTaxWorkflow 
                ? "AWAITING_PUBLISH"
                : revisionState
        }
        setEffectiveCurrentStage(currentStage)
      }
    },[selectedRevision,reviewInTaxWorkflow,approveInTaxWorkflow,publishInTaxWorkflow, hasBeenFullyReviewed, hasBeenFullyApproved]
  )
  useEffect(
    () => {
      let buttonText = 
        effectiveCurrentStage === "AWAITING_REVIEW" ? t("global_review")
        : effectiveCurrentStage === "AWAITING_APPROVAL" ? t("global_approve") 
        : effectiveCurrentStage === "AWAITING_PUBLISH" ? t("global_publish")
        : effectiveCurrentStage === "REVIEWED_AWAITING_APPROVAL_STAGE" ? t("workflow_begin_approval")
        : ""
      setButtonText(buttonText)
      setWorkflowText("")
    },[effectiveCurrentStage]
  )
  const isWorkflowActive = () => {
    let workflowActive = false

    const topicId = props.internalDocument.contentRVO.topic 
    ? props.internalDocument.contentRVO.topic.topicId
    : props.internalDocument.contentRVO.topicId

    let topic = props.taxonomyNodeLookup.filter(t => t.id === topicId && t.type === "topic")[0]
    if (topic) {
      workflowActive = topic.workflowActive && topic.workflowActive === true ? true : false 
    }
    return workflowActive
  }

  const getWorkflowDetails = (details) => {
    return (
      <>
        {details.map((el, idx) => {
          return (
            <div>
              <Typography variant="subtitle2">
                {moment(el.createdDate).fromNow()}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <DisplayUser userId={el.user.userId} user={el.user} />
              </Typography>
              <div className={classes.commentContainer}>
                <Typography variant="subtitle2">{el.comment}</Typography>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const getTimeline = () => {
    if (!selectedRevision || !selectedRevision.contentRVO) return;
    let requiresReviews = selectedRevision.contentRVO.requiresReviews;
    let hasReviews = selectedRevision.contentRVO.hasReviews;
    let requiresApprovals = selectedRevision.contentRVO.requiresApprovals;
    let hasApprovals = selectedRevision.contentRVO.hasApprovals;



    const reviewerStageEnabled =
      ((requiresReviews > 0 || hasReviews) && 
      workflowActive === true &&
      reviewInTaxWorkflow === true
        && (isSysAdmin || workflowUsers.reviewers > 0)) 
          ? true 
          : false
    const approvalStageEnabled =
      ((requiresApprovals > 0 || hasApprovals) && 
        workflowActive === true &&
        approveInTaxWorkflow === true
        && (isSysAdmin || workflowUsers.approvers > 0)) 
          ? true 
          : false
    const publishStageEnabled =
      ( workflowActive === true &&
        publishInTaxWorkflow === true
        && (isSysAdmin || workflowUsers.publishers > 0)) 
          ? true 
          : false

      
    // const autostartApproval =
    //   workflow !== null ? workflow.autostartApproval : false;

    return (
      <Timeline align="left" classes={{ root: classes.timelineRoot }}>
        <TimelineItem>
          <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
            <TimelineDot
              color={"secondary"}
              classes={{ root: classes.timelineDot }}
            />
            <TimelineConnector
              classes={{
                root:
                  !hasBeenFullyReviewed &&
                  // hasReviews < requiresReviews &&
                  selectedRevision.contentRVO.workflowState !==
                    "AWAITING_PUBLISH" &&
                  selectedRevision.contentRVO.workflowState !== "PUBLISHED" &&
                  selectedRevision.contentRVO.workflowState !== "SUPERCEDED"
                    ? classes.connectorDisabled
                    : classes.connectorEnabled,
              }}
            />
          </TimelineSeparator>
          <TimelineContent
            classes={{
              root:
                madeDraftBy
                  ? classes.timeLineContent
                  : classes.timeLineContentNoExp,
            }}
          >
            <KpsListItem
              hideExpand={madeDraftBy ? false : true}
              extendedString={
                madeDraftBy && madeDraftBy !== null ? (
                  <div className={classes.container}>
                    {
                      Array.isArray(madeDraftBy) ?
                        madeDraftBy.map((mdb) => {
                          return (
                            <div>
                              <Typography variant="subtitle2">
                                {moment(mdb.createdDate).fromNow()}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                <DisplayUser userId={mdb.user.userId} user={mdb.user} />
                              </Typography>
                            </div>
                          )
                        })
                        :
                        <div>
                          <Typography variant="subtitle2">
                            {moment(madeDraftBy.createdDate).fromNow()}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            <DisplayUser userId={madeDraftBy.user.userId} user={madeDraftBy.user} />
                          </Typography>
                        </div>
                    }
                  </div>
                ) : (
                  ""
                )
              }
            >
              <ListItemText
                primary={t("global_draft")}
                secondary={""}
              />
            </KpsListItem>
          </TimelineContent>
        </TimelineItem>
        {reviewerStageEnabled &&
          selectedRevision.contentRVO.workflowState !== "AWAITING_PUBLISH" &&
          // selectedRevision.contentRVO.workflowState !== "PUBLISHED" &&
          selectedRevision.contentRVO.workflowState !== "SUPERCEDED" && (
            <TimelineItem>
              <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
                <TimelineDot
                  variant={ hasBeenFullyReviewed === false ? "outlined" : "default"}
                  color={
                    hasBeenFullyReviewed === false ? "grey" : "secondary"}
                  classes={{ root: classes.timelineDot }}
                />
                <TimelineConnector
                  classes={{
                    root:
                      // hasApprovals < requiresApprovals
                      !hasBeenFullyReviewed
                        ? classes.connectorDisabled
                        : classes.connectorEnabled,
                  }}
                />
              </TimelineSeparator>
              <TimelineContent
                classes={{
                  root:
                    hasReviews > 0
                      ? classes.timeLineContent
                      : classes.timeLineContentNoExp,
                }}
              >
                <KpsListItem
                  hideExpand={hasReviews > 0 ? false : true}
                  extendedString={getWorkflowDetails(
                    selectedRevision.contentRVO.reviewers
                  )}
                >
                  <ListItemText
                    primary={t("workflow_progress_num_reviews", {
                      current: selectedRevision.contentRVO.reviewers.length,
                      total: totalReviewersRequiredToComplete,
                    })}
                    secondary={""}
                  />
                </KpsListItem>
              </TimelineContent>
            </TimelineItem>
          )}
        {approvalStageEnabled &&
          selectedRevision.contentRVO.workflowState !== "AWAITING_PUBLISH" &&
          // selectedRevision.contentRVO.workflowState !== "PUBLISHED" &&
          selectedRevision.contentRVO.workflowState !== "SUPERCEDED" && (
            <TimelineItem>
              <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
                <TimelineDot
                  variant={ hasBeenFullyApproved === false ? "outlined" : "default"}
                  color={
                    hasBeenFullyApproved === false ? "grey" : "secondary"}
                  classes={{ root: classes.timelineDot }}
                />
                <TimelineConnector
                  classes={{
                    root:
                      selectedRevision.contentRVO.workflowState ===
                        "AWAITING_PUBLISH" ||
                      selectedRevision.contentRVO.workflowState ===
                        "PUBLISHED" ||
                      selectedRevision.contentRVO.workflowState ===
                        "REMOVED_FROM_DRAFT"
                        ? classes.connectorEnabled
                        : classes.connectorDisabled,
                  }}
                />
              </TimelineSeparator>
              <TimelineContent
                classes={{
                  root:
                    hasApprovals > 0
                      ? classes.timeLineContent
                      : classes.timeLineContentNoExp,
                }}
              >
                <KpsListItem
                  hideExpand={hasApprovals > 0 ? false : true}
                  extendedString={getWorkflowDetails(
                    selectedRevision.contentRVO.approvers
                  )}
                >
                  <ListItemText
                    primary={t("workflow_progress_num_approvals", {
                      current: selectedRevision.contentRVO.approvers.length,
                      total: totalApproversRequiredToComplete,

                    })}
                    secondary={""}
                  />
                </KpsListItem>
              </TimelineContent>
            </TimelineItem>
          )}
        {selectedRevision.contentRVO.workflowState === "AWAITING_PUBLISH" && (
          <TimelineItem>
            <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
              <TimelineDot
                variant={
                  selectedRevision.contentRVO.workflowState ===
                  "AWAITING_PUBLISH"
                    ? "default"
                    : "outlined"
                }
                color={
                  selectedRevision.contentRVO.workflowState ===
                  "AWAITING_PUBLISH"
                    ? "secondary"
                    : "default"
                }
                classes={{ root: classes.timelineDot }}
              />
              <TimelineConnector
                classes={{
                  root:
                    selectedRevision.contentRVO.workflowState === "PUBLISHED"
                      ? classes.connectorEnabled
                      : classes.connectorDisabled,
                }}
              />
            </TimelineSeparator>
            <TimelineContent
              classes={{
                root:
                  hasApprovals > 0 || hasReviews > 0
                    ? classes.timeLineContent
                    : classes.timeLineContentNoExp,
              }}

            >
              <KpsListItem
                extendedString={
                  <>
                    <div className={classes.container}>
                    <Typography variant="subtitle1">{t("global_review_plural")}</Typography>
                      {hasReviews > 0 &&
                        getWorkflowDetails(
                          selectedRevision.contentRVO.reviewers
                        )
                      }
                    </div>
                    <div className={classes.container}>
                      <Typography variant="subtitle1">{t("global_approval_plural")}</Typography>
                      {hasApprovals > 0 &&
                        getWorkflowDetails(
                          selectedRevision.contentRVO.approvers
                        )
                      }
                    </div>
                  </>
                }
              >
                <ListItemText
                  primary={t("workflow_awaiting_publish")}
                  secondary={""}
                />
              </KpsListItem>
            </TimelineContent>
          </TimelineItem>
        )}
        {selectedRevision.contentRVO.workflowState === "REMOVED_FROM_DRAFT" && (
          <TimelineItem>
            <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
              <TimelineDot
                variant="default"
                color="secondary"
                classes={{ root: classes.timelineDotRemoved }}
              >
                <CloseIcon fontSize="small" />
              </TimelineDot>
              <TimelineConnector
                classes={{
                  root: classes.connectorDisabledMargin,
                }}
              />
            </TimelineSeparator>
            <TimelineContent style={{ marginLeft: -8, marginTop: -13 }}>
              <KpsListItem hideExpand={true}>
                <ListItemText
                  primary={t("workflow_removed_from_draft")}
                  secondary={""}
                />
              </KpsListItem>
            </TimelineContent>
          </TimelineItem>
        )}
        <TimelineItem>
          <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
            <TimelineDot
              variant={
                selectedRevision.contentRVO.workflowState === "PUBLISHED" ||
                selectedRevision.contentRVO.workflowState === "SUPERCEDED"
                  ? "default"
                  : "outlined"
              }
              color={                
                selectedRevision.contentRVO.workflowState === "PUBLISHED" ||
                selectedRevision.contentRVO.workflowState === "SUPERCEDED" 
                  ? "default" 
                  : "grey"}
              classes={{
                root:
                  selectedRevision.contentRVO.workflowState === "PUBLISHED" ||
                  selectedRevision.contentRVO.workflowState === "SUPERCEDED"
                    ? classes.timelineDotPublished
                    : classes.timelineDot,
              }}
            >
              {(selectedRevision.contentRVO.workflowState === "PUBLISHED" ||
                selectedRevision.contentRVO.workflowState === "SUPERCEDED") && (
                <CheckIcon fontSize="small" />
              )}
            </TimelineDot>
            {selectedRevision.contentRVO.workflowState === "SUPERCEDED" && (
              <TimelineConnector
                classes={{
                  root: classes.connectorEnabledMargin,
                }}
              />
            )}
          </TimelineSeparator>
          <TimelineContent
            classes={{ root: classes.timeLineContentNoExp }}
            style={
              selectedRevision.contentRVO.workflowState === "SUPERCEDED"
                ? { marginLeft: -8, marginTop: -13 }
                : {}
            }
          >
            <KpsListItem hideExpand={true}>
              <ListItemText
                primary={t("global_publish_past_tense")}
                // extendedString={
                //   publishedBy && publishedBy !== null ? (
                //     <div className={classes.container}>
                //       <div>
                //         <Typography variant="subtitle2">
                //           {moment(publishedBy.createdDate).fromNow()}
                //         </Typography>
                //         <Typography variant="body2" color="textSecondary">
                //           <DisplayUser userId={publishedBy.user.userId} user={publishedBy.user} />
                //         </Typography>
                //       </div>
                //     </div>
                //   ) : (
                //     ""
                //   )
                // }
                secondary={
                  selectedRevision.contentRVO.workflowState === "PUBLISHED" &&
                  publishedBy &&
                  publishedBy !== null ? (
                    // <div className={classes.container}>
                      <div>
                        <Typography variant="subtitle2">
                          {moment(publishedBy.createdDate).fromNow()}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          <DisplayUser userId={publishedBy.user.userId} user={publishedBy.user} />
                        </Typography>
                      </div>
                    // </div>
                  ) : (
                    ""
                  )
                }
              />
            </KpsListItem>
          </TimelineContent>
        </TimelineItem>
        {selectedRevision.contentRVO.workflowState === "SUPERCEDED" && (
          <TimelineItem>
            <TimelineSeparator classes={{ root: classes.timelineSeparator }}>
              <TimelineDot
                variant="default"
                color="secondary"
                classes={{ root: classes.timelineDotSuperseded }}
              >
                <ScheduleIcon fontSize="small" />
              </TimelineDot>
            </TimelineSeparator>
            <TimelineContent style={{ marginLeft: -8, marginTop: -13 }}>
              <KpsListItem hideExpand={true}>
                <ListItemText
                  primary={t("workflow_superseded")}
                  secondary={""}
                />
              </KpsListItem>
            </TimelineContent>
          </TimelineItem>
        )}
      </Timeline>
    );
  };

  const doAction = () => {
    setSaving(true);
    const knowledgeItemId = selectedRevision.contentRVO.itemId;

    const revisionId = selectedRevision.contentRVO.id
      ? selectedRevision.contentRVO.id
      : selectedRevision.contentRVO.revisionId;
    let snackbar = "";
    let update = {};
    switch (effectiveCurrentStage) {
      case "AWAITING_REVIEW":
        update = {
          itemId: knowledgeItemId,
          id: revisionId,
          reviewed: true,
          rationale: workflowText,
        };
        snackbar = "workflow_revision_reviewed";
        break;
      case "REVIEWED_AWAITING_APPROVAL_STAGE":
        update = {
          itemId: knowledgeItemId,
          id: revisionId,
          beginApproval: true,
        };
        snackbar = "workflow_approval_started";
        break;
      case "AWAITING_APPROVAL":
        update = {
          itemId: knowledgeItemId,
          id: revisionId,
          approved: true,
          rationale: workflowText,
        };
        snackbar = "workflow_revision_approved";
        break;
      case "AWAITING_PUBLISH":
        update = {
          itemId: knowledgeItemId,
          id: revisionId,
          publishContent: true,
          rationale: workflowText,
        };
        snackbar = "workflow_revision_published";
        break;
      default:
        return;
    }
    contentClient
      .post(`/knowledgeitem/${knowledgeItemId}/revision/${revisionId}`, update)
      .then((res) => {
        enqueueSnackbar(t(snackbar), {
          variant: "success",
        });
        setSaving(false);
        setWorkflowText("")
        if (res.data.workflowState === "PUBLISHED") {
          // made live, we can't get the live revision as it may not (99% likely) have been indexed yet
          // so the document service probably isn't aware it exists and will error. display a message instead
          setWorkflowComplete(true);
        } else {
          // props.getDocumentContent && props.getDocumentContent();
          setSelectedRevision(res.data);
        }
        props.updateDocumentWorkflow(res.data);
      })
      .catch((err) => {
        setSaving(false);
        enqueueSnackbar(
          t("workflow_error", { error: err.response.data.message }),
          {
            variant: "error",
          }
        );
      });
  };

  const hasPermissions = () => {
    if (effectiveCurrentStage === "AWAITING_REVIEW") {
      return currentUserHasRole(Role.REVIEWER);
    }
    if (effectiveCurrentStage === "AWAITING_APPROVAL") {
      return currentUserHasRole(Role.APPROVER);
    }
    if (effectiveCurrentStage === "AWAITING_PUBLISH") {
      return (
        selectedRevision.contentRVO.autoPublish ||
        currentUserHasRole(Role.PUBLISHER) || (workflowUsers.publishers === 0 && currentUserHasRole(Role.BE_EXPERT))
      );
    }
    return true;
  };

  const canApproveReviewOwn = () => {
    if (effectiveCurrentStage === "AWAITING_REVIEW") {
      if (
        !selectedRevision.contentRVO.reviewOwn &&
        selectedRevision.contentRVO.authorId !== null &&
        selectedRevision.contentRVO.authorId === currentUser.userId
      ) {
        return false;
      }
    }
    if (effectiveCurrentStage === "AWAITING_APPROVAL") {
      if (
        !selectedRevision.contentRVO.approveOwn &&
        selectedRevision.contentRVO.authorId !== null &&
        selectedRevision.contentRVO.authorId === currentUser.userId
      ) {
        return false;
      }
    }
    return true;
  };

  const hasAlreadyReviewedApproved = () => {
    if (effectiveCurrentStage === "AWAITING_REVIEW") {
      if (
        selectedRevision.contentRVO.reviewers.filter(
          (r) => r.user.userId === currentUser.userId
        ).length > 0
      ) {
        return true;
      }
    }
    if (effectiveCurrentStage === "AWAITING_APPROVAL") {
      if (
        selectedRevision.contentRVO.approvers.filter(
          (r) => r.user.userId === currentUser.userId
        ).length > 0
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      {props.show && (
        <>
          {isLoading ? (
            <div>
              <CardHeader
                titleTypographyProps={{ component: "h3" }}
                title={t("revision_workflow")}
                subheader={
                  <Skeleton
                    className={classes.skeleton}
                    animation="wave"
                    variant="rect"
                    width={200}
                    height={40}
                  />
                }
                action={
                  <>
                    {props.toggleSidebar && (
                      <IconButton
                        onClick={props.toggleSidebar}
                        aria-label="Close sidebar"
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                  </>
                }
              />
              <Skeleton
                className={classes.skeleton}
                animation="wave"
                variant="rect"
                width={250}
                height={350}
              />
              <br />
              <Skeleton
                className={classes.skeleton}
                variant="text"
                height={20}
              />
              <Skeleton
                className={classes.skeleton}
                variant="rect"
                width={250}
                height={100}
              />
              <Skeleton
                className={classes.skeleton}
                variant="rect"
                width={150}
                height={40}
              />
            </div>
          ) : (
            <>
              <CardHeader
                titleTypographyProps={{ component: "h3" }}
                title={t("revision_workflow")}
                subheader={
                  selectedRevision &&
                  selectedRevision.contentRVO &&
                  selectedRevision.contentRVO.author !== null &&
                  typeof selectedRevision.contentRVO.author === "object" ? (
                    <DisplayUser
                      userId={selectedRevision.contentRVO.author.userId}
                      user={selectedRevision.contentRVO.author}
                    />
                  ) : selectedRevision &&
                  selectedRevision.contentRVO &&
                  selectedRevision.contentRVO.author !== null ? (
                    `${selectedRevision.contentRVO.author}`
                  ) : (
                    ""
                  )
                }
                action={
                  <>
                    {props.toggleSidebar && (
                      <IconButton
                        onClick={props.toggleSidebar}
                        aria-label="Close sidebar"
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                  </>
                }
              />
              <CardContent>
                {workflowComplete ? (
                  <div style={{ width: "100%", marginTop: 50 }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div style={{ textAlign: "center" }}>
                        <svg
                          className={classes.checkmark}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 52 52"
                        >
                          <circle
                            className={classes.checkmarkCircle}
                            cx="26"
                            cy="26"
                            r="25"
                            fill="none"
                          />
                          <path
                            className={classes.checkmarkCheck}
                            fill="none"
                            d="M14.1 27.2l7.1 7.2 16.7-16.8"
                          />
                        </svg>
                        <Typography style={{ marginTop: 30 }}>
                          {t("workflow_complete_header")}
                        </Typography>
                        <Typography style={{ marginTop: 30 }}>
                          {t("workflow_complete_subheader")}
                        </Typography>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div>{getTimeline()}</div>
                    <div style={{ marginTop: 20, textAlign: "center" }}>
                      <div style={{ textAlign: "left" }}>
                        {!hasPermissions() ? (
                          <Alert
                            severity="warning"
                            style={{ marginBottom: 20 }}
                          >
                            {t("workflow_no_permissions")}
                          </Alert>
                        ) : (
                          <>
                            {effectiveCurrentStage ===
                              "AWAITING_REVIEW" && (
                              <div style={{ marginBottom: 20 }}>
                                {!canApproveReviewOwn() ? (
                                  <Alert severity="warning">
                                    {t("workflow_cannot_review_own")}
                                  </Alert>
                                ) : hasAlreadyReviewedApproved() ? (
                                  <>
                                    <Alert severity="warning">
                                      {t("workflow_already_reviewed")}
                                    </Alert>
                                  </>
                                ) : (
                                  <Alert severity="info">
                                    {t("workflow_revision_requires_review")}
                                  </Alert>
                                )}
                              </div>
                            )}
                            {effectiveCurrentStage ===
                              "AWAITING_APPROVAL" && (
                              <div style={{ marginBottom: 20 }}>
                                {!canApproveReviewOwn() ? (
                                  <Alert severity="warning">
                                    {t("workflow_cannot_approve_own")}
                                  </Alert>
                                ) : hasAlreadyReviewedApproved() ? (
                                  <Alert severity="warning">
                                    {t("workflow_already_approved")}
                                  </Alert>
                                ) : (
                                  <>
                                    <Alert severity="info">
                                      {t("workflow_revision_requires_approval")}
                                    </Alert>
                                    {hasReworks && (
                                      <Alert
                                        severity="error"
                                        style={{ marginTop: 10 }}
                                      >
                                        {t(
                                          "workflow_revision_has_open_reworks_approve"
                                        )}
                                      </Alert>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                            {effectiveCurrentStage ===
                              "AWAITING_PUBLISH" && (
                              <div style={{ marginBottom: 20 }}>
                                <Alert severity="info">
                                  {t("workflow_revision_waiting_for_publish")}
                                </Alert>
                                {hasReworks && (
                                  <Alert
                                    severity="error"
                                    style={{ marginTop: 10 }}
                                  >
                                    {t(
                                      "workflow_revision_has_open_reworks_publish"
                                    )}
                                  </Alert>
                                )}
                              </div>
                            )}
                            {effectiveCurrentStage ===
                              "REVIEWED_AWAITING_APPROVAL_STAGE" && (
                              <div style={{ marginBottom: 20 }}>
                                <Alert severity="info">
                                  {t(
                                    "workflow_revision_waiting_for_approval_stage"
                                  )}
                                </Alert>
                                {hasReworks && (
                                  <Alert
                                    severity="error"
                                    style={{ marginTop: 10 }}
                                  >
                                    {t("workflow_revision_has_open_reworks")}
                                  </Alert>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      {!saving && effectiveCurrentStage !==
                        "REVIEWED_AWAITING_APPROVAL_STAGE" &&
                        effectiveCurrentStage !==
                        "PUBLISHED" &&
                        effectiveCurrentStage !==
                        "REMOVED_FROM_DRAFT" &&
                        effectiveCurrentStage !==
                        "SUPERCEDED" && (
                          <TextField
                            defaultValue={""}
                            onChange={(e) => setWorkflowText(e.target.value)}
                            label={t("workflow_comment")}
                            multiline
                            disabled={
                              hasAlreadyReviewedApproved() ||
                              !canApproveReviewOwn()
                            }
                            variant="outlined"
                            rows={3}
                          />
                        )}
                      {effectiveCurrentStage !==
                        "PUBLISHED" &&
                        effectiveCurrentStage !==
                        "REMOVED_FROM_DRAFT" &&
                        effectiveCurrentStage !==
                        "SUPERCEDED" && (
                          <ActionButton
                            id="workflow-action-button"
                            loading={saving}
                            variant="contained"
                            disabled={
                              hasAlreadyReviewedApproved() ||
                              !canApproveReviewOwn() ||
                              !hasPermissions()
                            }
                            style={{ marginTop: 10 }}
                            onClick={doAction}
                          >
                            {buttonText}
                          </ActionButton>
                      )}
                    </div>
                  </>
                )}
              </CardContent>
            </>
          )}
        </>
      )}
    </>
  );
}
const mapStateToProps = (state) => ({
  isMobile: state.screen.isMobile,
  taxonomyTree: state.taxonomy.taxonomyTree,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(SidebarWorkflow));
